<ng-content></ng-content>

<div class="templates">
  <ng-container *ngFor="let templateData of (templates$ | async)">
    <ng-container *ngTemplateOutlet="templateData.template;context:{payload: templateData.payload}" ></ng-container>
  </ng-container>
</div>
